export default __webpack_public_path__ + "static/media/support.3063bef1.png";